module.exports = __webpack_public_path__ + "static/media/icon-notes-green.6f4ffd47.svg";